var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDroppin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7467 5.63341C13.0467 2.55341 10.36 1.16675 8 1.16675C8 1.16675 8 1.16675 7.99333 1.16675C5.64 1.16675 2.94667 2.54675 2.24667 5.62675C1.46667 9.06675 3.57333 11.9801 5.48 13.8134C6.18667 14.4934 7.09333 14.8334 8 14.8334C8.90667 14.8334 9.81333 14.4934 10.5133 13.8134C12.42 11.9801 14.5267 9.07341 13.7467 5.63341ZM8 8.97341C6.84 8.97341 5.9 8.03341 5.9 6.87341C5.9 5.71341 6.84 4.77341 8 4.77341C9.16 4.77341 10.1 5.71341 10.1 6.87341C10.1 8.03341 9.16 8.97341 8 8.97341Z",
    fill: "#717680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroppin);
export default __webpack_public_path__ + "static/media/droppin.78b27831f9c1f7c921f1ef34374625d8.svg";
export { ForwardRef as ReactComponent };